<template>
  <eventi-edit-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" :titoloEvento="titoloEvento" @update="onUpdateJsonData" :isImmagini="true" :isAllegati="false" :isPrestazioni="true">
    <template slot="tab-content-event">
      <gastro-ano-retto-colonscopia-edit-component :jsonData="jsonData" @update="onUpdateJsonData"></gastro-ano-retto-colonscopia-edit-component>
    </template>
  </eventi-edit-component>
</template>
<script>
import EventiEditComponent from "../../../base/components/EventiEditComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import GastroAnoRettoColonscopiaEditComponent from "./GastroAnoRettoColonscopiaEditComponent.vue";
export default {
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  mixins: [UtilityMixin, EventiMixin],
  components: {
    EventiEditComponent,
    GastroAnoRettoColonscopiaEditComponent,
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    this.jsonData.dataEvento = new Date().getTime();
  },
  data() {
    return {
      data: {},
      jsonData: {
        dataEvento: null,
        motivoEsame: null,
        provenienza: null,
        colon: null,
        canaleAnale: null,
        terapieInAtto: null,
        diagnosiColon: null,
        diagnosiCanaleAnale: null,
        diagnosi: null,
        propostaTerapeutica: null,
        dataControlloEndoscopico: null,
        corpoReferto: null,
        premedicazione: null,
        consigliTerapeutici: null,
        strumento: null,
        listaOperatori: [],
      },
      linkback: null,
      titoloEvento: this.getLabelTraduora("patients.gastroenterology.anusRectumColonoscopy"),
      pathResource: "/gastroanorettocolonscopia",
      pathRestValidation: "/validation",
      id: "-1",
      isFirmato: false,
      childKey: 0,
      tabIndex: 0,
      showModalLoading: false,
    };
  },
  methods: {
    onFirmaUpdate() {
      let me = this;
      me.loadData();
    },
    onUpdateFile() {
      let me = this;
      me.childKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
    },
  },
};
</script>
